import * as React from 'react';
import { AppContext } from '../../../AppModulesWrapper';
import { Device } from '../common/Device';
import { HiddenBaseDesktop } from './HiddenBase.desktop';
import { HiddenBaseMobile } from './HiddenBase.mobile';

export const HiddenBaseContainer = () => {
  const { isMicrofrontend } = React.useContext(AppContext);

  return isMicrofrontend ? null : <Device mobile={<HiddenBaseMobile />} desktop={<HiddenBaseDesktop />} />;
};
